module.exports = __webpack_public_path__ + "img/s03_p03-big.495a8330.png";